import _ from 'lodash';
import { withSiteMeta } from '../../HOCS/withSiteMeta';
import { useListCarousel } from '../../scripts/hooks/useListCarousel';

// switch house ads this often
const HOUSE_AD_CYCLE_INTERVAL_SECONDS = 60;

export const HouseAds: any = withSiteMeta((props: any) => {
  if (props.currentFeatures.no_ads) {
    return null;
  }

  const ad = useListCarousel((props as any).siteConfig.houseAds?.[props.type], {
    delaySeconds: HOUSE_AD_CYCLE_INTERVAL_SECONDS
  });
  if (!ad) {
    return null;
  }

  return <props.component {..._.pick(props, 'width', 'height')} ad={ad} />;
});
